// Internal
import { getDataTestId } from "../functions/data-test-ids";
import { Icon } from "../icons/icons.jsx";
import { Tooltip } from "../tooltip/tooltip.jsx";

// CSS
import "./button-toggle.css";

export const ButtonToggleAlignment = {
    Center: 1,
    Left: 2,
    Right: 3
};

function ButtonToggleOption(props) {
    const onClick = () => {
        if (typeof props.OnChange === "function") {
            props.OnChange(props.Value);
        }
    };

    const className = props.Active ? "eone-ui-button-toggle-option-active" : "eone-ui-button-toggle-option";
    return (
        <button type="button" className={className} onClick={onClick} data-testid={getDataTestId(props.DataTestId, props.Value)}>
            <ButtonToggleIcon Icon={props.Icon} IconType={props.IconType} />
            <span className="eone-ui-button-toggle-option-label">{props.Label}</span>
            <ButtonToggleBadge Text={props.BadgeText} Active={props.Active} />
            <Tooltip
                Title={props.TooltipTitle || props.Label}
                Tooltip={props.Tooltip}
                DataTestId={props.DataTestId} />
        </button>
    );
}

function ButtonToggleIcon(props) {
    if (!props.Icon) {
        return null;
    }
    return (
        <span className="eone-ui-button-toggle-option-icon">
            <Icon Icon={props.Icon} Type={props.IconType} FixedWidth={true} />
        </span>
    );
}

function ButtonToggleBadge(props) {
    if (props.Text === undefined || props.Text === null || props.Text === "") {
        return null;
    }
    const className = props.Active ? "eone-ui-button-toggle-badge-active" : "eone-ui-button-toggle-badge";
    return (
        <span className={className}>{props.Text}</span>
    );
}

function ButtonToggle(props) {
    const onChange = (value) => {
        if (typeof props.OnChange === "function") {
            props.OnChange(value);
        }
    };

    const getAlignment = () => {
        switch (props.Alignment) {
            case ButtonToggleAlignment.Left:
                return "flex-start";
            case ButtonToggleAlignment.Right:
                return "flex-end";
            case ButtonToggleAlignment.Center:
                return "center";
        }
    };

    const getStyle = () => {
        const style = {};
        if (props.Width) {
            style.width = props.Width;
        }
        if (props.Alignment) {
            style.justifyContent = getAlignment();
        }
        return style;
    };

    if (props.Visible !== undefined && !props.Visible) {
        return null;
    }

    const options = props.Options.filter(option => option.Visible === undefined || option.Visible === true);
    if (options.length === 0) {
        return null;
    }

    return (
        <div className="eone-ui-button-toggle" style={getStyle()}>
            {options.map((option, index) => (
                <ButtonToggleOption
                    key={index}
                    Value={option.Value}
                    Label={option.Label}
                    Icon={option.Icon}
                    IconType={option.IconType}
                    BadgeText={option.BadgeText}
                    Active={option.Value === props.Value}
                    Tooltip={option.Tooltip}
                    TooltipTitle={option.TooltipTitle}
                    OnChange={onChange}
                    DataTestId={props.DataTestId} />
            ))}
        </div>
    );
}

export { ButtonToggle };
